import MuiButton from "@mui/material/Button";
const Button = MuiButton;
export default Button;
